import { render, staticRenderFns } from "./JFormContainer.vue?vue&type=template&id=52390d51&"
import script from "./JFormContainer.vue?vue&type=script&lang=js&"
export * from "./JFormContainer.vue?vue&type=script&lang=js&"
import style0 from "./JFormContainer.vue?vue&type=style&index=0&id=52390d51&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports